import UserPreferencesRepository from './UserPreferencesRepository';

export default UserPreferencesRepository;
